module.exports = __webpack_public_path__ + "static/img/live-agent.f5b68ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live-agent.png
// module id = 8sCq
// module chunks = 1